@for (card of content; track $index) {
  <div
    class="skyclub-tracker__card"
    [attr.data-cy]="
      'skyclub-spend-tracker-card-visits-available-card-' + ($index + 1)
    "
  >
    @if ($index === carouselIndex) {
      <div
        class="skyclub-tracker__card__content {{
          card.thresholdMet ? 'threshold-met-content' : ''
        }}"
      >
        <div
          class="skyclub-tracker__card__content__visit  {{
            card.thresholdMet ? 'threshold-met-visit' : ''
          }} {{
            card.visit.count && card.visit.count !== 0 ? '' : 'no-count'
          }} {{
            card.visit.count !== undefined && card.visit.count === 0
              ? 'zero-visits'
              : ''
          }}"
          [ngStyle]="{
            'background-image': 'url(' + card.visit.image?.src + ')'
          }"
          role="status"
          [attr.aria-label]="
            (card.visit.count || 0) +
            ' visits available with your ' +
            card.type.name
          "
        >
          @if (card.visit.count && card.visit.count !== 0) {
            <div
              class="skyclub-tracker__card__content__visit__count"
              [style.--progress]="progressValue"
            >
              <span
                class="skyclub-tracker__card__content__visit__count-value"
                [innerHTML]="card.visit.count"
                data-cy="skyclub-spend-tracker-card-visits-available-number"
              ></span>
            </div>
          }
          <div
            class="skyclub-tracker__card__content__visit-title {{
              card.visit.count !== undefined && card.visit.count === 0
                ? 'zero-visits-title'
                : ''
            }}"
            [innerHTML]="card.visit.title"
            data-cy="skyclub-spend-tracker-card-visits-available-text"
          ></div>
          @if (card.visit.description) {
            <div
              class="skyclub-tracker__card__content__visit-description {{
                card.visit.count !== undefined && card.visit.count === 0
                  ? 'zero-visits-description'
                  : ''
              }}"
              [innerHTML]="card.visit.description"
              data-cy="skyclub-spend-tracker-card-visits-available-description"
            ></div>
          }
        </div>
        <div
          class="skyclub-tracker__card__content__type"
          data-cy="skyclub-spend-tracker-card-description"
        >
          <span
            class="skyclub-tracker__card__content__type-name"
            [innerHTML]="card.type.name"
            data-cy="skyclub-spend-tracker-card-type-label"
          ></span>
          @if (card.type.terms.url) {
            <span class="skyclub-tracker__card__content__type-label">
              <a
                [innerHTML]="card.type.terms.label"
                [href]="card.type.terms.url"
                target="_blank"
                (click)="onTermsLinkClick(card, $index, 'link')"
              ></a>
            </span>
          }
          @if (card.type.terms.information) {
            <button
              [id]="'skyclub-tracker__card__content__type-tooltip--' + $index"
              auraTooltip
              [tooltipContent]="{
                position: 'bottom-right',
                trapFocus: true,
                hideCloseIcon: false,
                color: '#0b1f66',
                info: card.type.terms.information
              }"
              class="skyclub-tracker__card__content__type-icon"
              [attr.aria-label]="card.type.name + ' help icon' || ''"
              [attr.aria-describedby]="'spend-tracker-card-tooltip'"
              [attr.data-cy]="
                'skyclub-spend-tracker-card-tooltip-' + ($index + 1)
              "
              role="button"
              (click)="onTermsLinkClick(card, $index, 'tooltip')"
            >
              <img alt="Info Icon" role="img" />
            </button>
          }
        </div>
      </div>
      <div
        class="skyclub-tracker__card__footer-wrapper"
        [class.footer-threshold-met]="
          content[$index].spendTracker?.thresholdMet
        "
        role="complementary"
        [attr.aria-label]="
          content[$index].spendTracker
            ? 'Spend tracker information'
            : 'Sky Club search information'
        "
      >
        @if (
          content[$index].spendTracker || content[$index].searchEligibleFooter
        ) {
          <idp-skyclub-spend-tracker-footer
            class="sky-club-tracker__card__spend-tracker-footer"
            [content]="
              content[$index].spendTracker ||
              content[$index].searchEligibleFooter!
            "
            (searchEligibleClick)="
              onSearchEligibleClick(
                $event,
                $index,
                content[$index].spendTracker ||
                  content[$index].searchEligibleFooter
              )
            "
          ></idp-skyclub-spend-tracker-footer>
        }
      </div>
    }
  </div>
}
